import { AfterViewInit, Component, Injector, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RouteDataService } from '@services/route-data/route-data.service';
import { TableFunctionsService } from '@services/table/table-functions.service';
import { plainToClass } from 'class-transformer';
import '@angular/localize/init';
import { ComponentBase } from '@abstracts/component-base';
import { OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { User } from '@models/identity/user';
import { UsersService } from '@services/entity/users.service';

@Component({
  selector: 'app-user-overview',
  templateUrl: './user-overview.component.html',
  styleUrls: ['./user-overview.component.scss']
})
export class UserOverviewComponent extends ComponentBase implements OnInit, OnDestroy {

  public className = 'UserOverviewComponent';

  public primaryKey;
  public user: User;

  public activeTab = 'profile';

  public routerSubscription: Subscription;

  links = [
    { title: $localize`:@@UserOverviewProfileTitle:Profil`, route: 'profile' }
  ];

  constructor(
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public tableFunctions: TableFunctionsService,
    private dialog: NgbModal,
    private routeDataService: RouteDataService,
    private usersService: UsersService,
    injector: Injector) {
      super(injector);
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.routeDataService.params = this.activatedRoute.snapshot.params;
    this.primaryKey = this.activatedRoute.snapshot.params.key;

    this.initializeEntity();

    this.determineActiveTab();

    this.eventService.entityRefresh$.subscribe(result => {
      this.initializeEntity();
    });

    this.routerSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.determineActiveTab();
      }
    });
  }

  ngOnDestroy(): void {
    this.routerSubscription.unsubscribe();
  }

  initializeEntity() {
    this.usersService.getEntity(this.primaryKey).subscribe(result => {
      this.user = plainToClass(User, result);
    }, error => {});
  }

  determineActiveTab() {
    var currentRoute = this.activatedRoute.children[0]?.snapshot.url[0]?.path;
    for (let link of this.links) {
      if (currentRoute == link.route) {
        this.activeTab = link.route;
      }
    }
  }
}